/**
 * @vuepress
 * ---
 * title: usersTransfomer
 * ---
 */

import Transformer from '../transformer'

/**
 * @class usersTransfomer
 * Users info
 * @author José Luis R. <jose.ruiz@jbge.com.mx>
 */

const userFullName = ({ first_name: firstName, last_name: lastName }) => `${firstName || ''}${lastName ? " " + lastName : ''}`

class usersTransfomer extends Transformer {
  static fetch(user) {
    return {
      id: user.id,
      email: user.email,
      username: user.username,
      treatment: user.treatment,
      fullName: userFullName(user),
      firstName: user.first_name,
      lastName: user.last_name,
      isActive: user.is_active,

    }
  }
}
export default usersTransfomer



// WEBPACK FOOTER //
// ./src/transformers/extranet/users.js